"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var http_1 = require("@angular/common/http");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var audit_item_model_1 = require("./audit-item.model");
var core_1 = require("@angular/core");
var rxjs_1 = require("rxjs");
var AuditService = /** @class */ (function () {
    function AuditService(http, applicationPropertiesService) {
        this.http = http;
        this.GET_CHANGES_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/change"], ["", "/change"])), 'serviceUri');
        this.GET_CHANGES_COUNT_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/change/count"], ["", "/change/count"])), 'serviceUri');
        this.serviceApiKey = 'audit-service-url';
        this.loadedServiceUrl = applicationPropertiesService
            .getProperty(this.serviceApiKey);
    }
    AuditService.prototype.getAuditItems = function (filter) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filter);
        var search = filter.toHttpParams();
        return rxjs_1.Observable.from(this.loadedServiceUrl)
            .mergeMap(function (serviceUrl) {
            var url = _this.GET_CHANGES_URL.replaceTemplate({ serviceUri: serviceUrl });
            return _this.get(url, search);
        })
            .map(audit_item_model_1.AuditItem.asEntries);
    };
    AuditService.prototype.getAuditItemsCount = function (filter) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filter);
        var search = filter.toHttpParams();
        return rxjs_1.Observable.from(this.loadedServiceUrl)
            .mergeMap(function (serviceUrl) {
            var url = _this.GET_CHANGES_COUNT_URL.replaceTemplate({ serviceUri: serviceUrl });
            return _this.get(url, search);
        })
            .map(function (count) {
            var retCount = Number(count);
            if (Number.isNaN(retCount)) {
                return 0;
            }
            return retCount;
        });
    };
    AuditService.prototype.get = function (url, searchParams) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        var options = searchParams == null ? { 'headers': headers } : { 'headers': headers, 'params': searchParams };
        return this.http
            .get(url, options)
            .map(function (response) { return response || {}; });
    };
    AuditService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    AuditService.ctorParameters = function () { return [
        { type: idm_authentication_client_js_1.HttpClientWrapper, },
        { type: idm_application_properties_service_client_js_1.ApplicationPropertiesService, },
    ]; };
    return AuditService;
}());
exports.AuditService = AuditService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=audit.service.js.map